export const menuData = [
    {title: "About", link:"/about"},
    {title: "Trips", link:"/trips"},
    {title: "Careers", link:"/careers"},
    {title: "Contact", link:"/contact"},
]